export default __webpack_public_path__ + "33c17b55449e82fe5014abe6b02cc0e9.svg";